var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 2.6501C5.9408 2.6501 2.6501 5.9408 2.6501 10.0001C2.6501 14.0594 5.9408 17.3501 10.0001 17.3501C14.0594 17.3501 17.3501 14.0594 17.3501 10.0001C17.3501 5.9408 14.0594 2.6501 10.0001 2.6501ZM1.3501 10.0001C1.3501 5.22283 5.22283 1.3501 10.0001 1.3501C14.7774 1.3501 18.6501 5.22283 18.6501 10.0001C18.6501 14.7774 14.7774 18.6501 10.0001 18.6501C5.22283 18.6501 1.3501 14.7774 1.3501 10.0001ZM12.9597 7.04048C13.2136 7.29432 13.2136 7.70588 12.9597 7.95972L10.9193 10.0001L12.9597 12.0405C13.2136 12.2943 13.2136 12.7059 12.9597 12.9597C12.7059 13.2136 12.2943 13.2136 12.0405 12.9597L10.0001 10.9193L7.95972 12.9597C7.70588 13.2136 7.29432 13.2136 7.04048 12.9597C6.78664 12.7059 6.78664 12.2943 7.04048 12.0405L9.08086 10.0001L7.04048 7.95972C6.78664 7.70588 6.78664 7.29432 7.04048 7.04048C7.29432 6.78664 7.70588 6.78664 7.95972 7.04048L10.0001 9.08086L12.0405 7.04048C12.2943 6.78664 12.7059 6.78664 12.9597 7.04048Z",
    fill: "#5E666E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.eea1b8dd32184bc95489ac0956f6d0b5.svg";
export { ForwardRef as ReactComponent };